import { connect } from 'react-redux'
import HomeView from './PageHome.component'
import * as urls from '../../constants/api'
import { saveOriginPath, checkOperationType, retrivePropertyTypes } from '../../actions/searchBar'
import { loadRelevantProperties } from '../../actions/propiedades'
import { loadDirectors, loadImis, loadNewsHome } from '../../actions/home'
import { loadHomeBanners } from '../../actions/banners'
import { setPhone } from '../../actions/header'
import * as tel from '../../constants/phones'
import { retriveLandUses } from '../../actions/terrains'
import { getServices } from '../../actions/services'

const mapStateToProps = (state) => {
  return {
    newsList: state.home.news,
    relevantsList: state.propiedades.relevantResidentials,
    directors: state.home.directors,
    banners: state.banners.list,
    imis: state.home.imis,
    services: state.services.list,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    didMount: value => {
      dispatch(setPhone(tel.TEL_HOME))
      dispatch(retrivePropertyTypes(urls.HOME))
      dispatch(checkOperationType())
      dispatch(loadHomeBanners())
      dispatch(loadRelevantProperties(6))
      dispatch(loadDirectors())
      dispatch(loadImis(12))
      dispatch(loadNewsHome())
      dispatch(saveOriginPath(value))
      dispatch(retriveLandUses())
      dispatch(getServices())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeView)



// WEBPACK FOOTER //
// ./src/features/PageHome/PageHome.container.js